import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";

// UI
import { Header, HeaderPage, Box, Row, Col } from "../../ui";

class SettingsIndexPage extends Component {
  state = {
    titleHeader: "Настройки",
    user: { role_id: {}, filial_id: {} }
  };

  render() {
    const { user } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage title="Настройки" />

        <Box>
          <Header size={2} margin="no-top">
            {user.username}
          </Header>

          <Row>
            <Col padding="no-top-left">
              <ul>
                <li>
                  <Link to="/settings/account">Профиль</Link>
                </li>
                <li>
                  <Link to="/settings/templates">Шаблоны документов</Link>
                </li>
                <li>
                  <Link to="/settings/markers">Маркеры</Link>
                </li>
                <li>
                  <Link to="/settings/calc/gesv">Калькулятор - ГЭСВ</Link>
                </li>
                <li>
                  <Link to="/public/reports">Отчётность</Link>
                </li>
              </ul>
            </Col>
          </Row>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withAuth(SettingsIndexPage));
